import { render, staticRenderFns } from "./TriumphTrack.vue?vue&type=template&id=22d41fb9&scoped=true&"
import script from "./TriumphTrack.vue?vue&type=script&lang=js&"
export * from "./TriumphTrack.vue?vue&type=script&lang=js&"
import style0 from "./TriumphTrack.vue?vue&type=style&index=0&id=22d41fb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d41fb9",
  null
  
)

export default component.exports